export default "__VITE_ASSET__DocTe$ih__"